export default "__VITE_ASSET__DFa2u3Hl__"